import { render, staticRenderFns } from "./EventVideoUpload.vue?vue&type=template&id=1c645ac7&"
import script from "./EventVideoUpload.vue?vue&type=script&lang=js&"
export * from "./EventVideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./EventVideoUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports